/**
 * @param {*} state
 */
export const sales = state => state.sales

/**
 * @param {*} state
 */
export const sale = state => state.sale

/**
 * @param {*} state
 */
export const selectedSales = state => state.selectedSales
  ? state.selectedSales
  : []

/**
 * @param {*} state
 */
export const clients = state => {
  let options = [
    {
      value: 'all',
      label: 'Todos'
    }
  ]

  state.clients.map(item => {
    options.push({
      value: item.id,
      label: item.name
    })
  })

  return {
    label: 'Integrações',
    placeholder: 'Filtro de pedidos por integração',
    options: options,
    selected: {
      value: 'all',
      label: 'Todos'
    }
  }
}
/**
 * @param {*} state
 */
export const pagination = state => state.pagination

/**
 * @param {*} state
 */
export const filters = state => state.filters

/**
 * @param {*} state
 */
export const cepData = state => state.cepData
